export enum LocalStorageConstants {
	AWS_REGISTRATION_TOKEN = "aws_registration_token",
}
